<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-10"><a id="_idTextAnchor010"></a>Birth Pangs</h2>
<p class="Verse-long-new">In the passionate eye of God</p>
<p class="Verse-long">(the raging stream of life)</p>
<p class="Verse-long">fruit ripens red, grey cities vermillion</p>
<p class="Verse-long">birth-pangs all, agony and celebration</p>
<p class="Verse-long">graffiti inscribed by lovers</p>
<p class="Verse-long">on the merging body of the groaning world</p>
<p class="Verse-long">ruby light arcing with the pain of severed life</p>
<p class="Verse-long">each wilderness a crucible of God</p>
<p class="Verse-long">and common place of all</p>
<p class="Verse-long">where gracious hands break moulds</p>
<p class="Verse-long">and form the violent love, the terror,</p>
<p class="Verse-long">excesses of an ancient river flowing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-12.vue?cc33402e